/**
 * UIDGenerator - Genera IDs únicos para GameObjects en runtime
 *
 * Uso:
 *   import { UID } from './UIDGenerator';
 *   gameObject.setData('uid', UID.next());
 */

class UIDGenerator {
  private counter = 0;

  /**
   * Genera el siguiente UID único
   */
  next(): number {
    return ++this.counter;
  }

  /**
   * Resetea el contador (llamar al cargar un nuevo nivel)
   */
  reset(): void {
    this.counter = 0;
  }

  /**
   * Obtiene el valor actual del contador (sin incrementar)
   */
  current(): number {
    return this.counter;
  }
}

// Singleton exportado
export const UID = new UIDGenerator();
